/*
 * Jira Ticket:
 * Created Date: Thu, 26th Mar 2020, 13:25:22 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useEffect, useState } from 'react';
import {
  TopToolbar,
  CreateButton,
  fetchEnd,
  fetchStart,
  sanitizeListRestProps,
  useDataProvider,
  useNotify,
} from 'react-admin';
import { useDispatch } from 'react-redux';
import { Help } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';
import getHelp from 'utils/getHelp';
import getAllCapabilities from 'utils/getAllCapabilities';

const SubscriptionTierActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter = false, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const dispatch = useDispatch();
  const [capabilities, setCapabilities] = useState(null);
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);

  useMountEffect(
    getAllCapabilities({ dataProvider, dispatch, notify, setCapabilities })
  ); // run once

  useMountEffect(
    getHelp('help_url_subscription', { dataProvider, dispatch, setHelpLink })
  ); // run once

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <ActionButton
          label="resources.General.help"
          variant="text"
          onClick={() => {
            window.open(helpLink);
          }}
          icon={<Help />}
        />
      )}
      {capabilities && (
        <CreateButton
          basePath={basePath}
          to={{
            pathname: `${basePath}/create`,
            state: { record: { capabilities } },
          }}
        />
      )}
    </TopToolbar>
  );
};

SubscriptionTierActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default SubscriptionTierActions;
